export default [
  {
    name: 'レポート',
    isSeparator: true
  },
  {
    name: 'スライドレポート',
    slug: 'slide_report_group',
    icon: 'file-text',
    submenu: [
      {
        url: '/slide-report',
        name: 'マンスリーレポート',
        slug: 'slide-report'
      },
      {
        url: '/measure',
        name: '施策レポート',
        slug: 'measure'
      }
    ]
  },
  {
    name: 'トレンドレポート',
    slug: 'trend_report_group',
    icon: 'trending-up',
    submenu: [
      {
        url: '/',
        name: '日別',
        slug: 'dashboard'
      },
      {
        url: '/trend',
        name: '月別',
        slug: 'trend'
      },
      {
        url: '/analytics',
        name: '商品別',
        slug: 'analytics'
      }
    ]
  },
  {
    url: '/campaign-report',
    name: 'キャンペーンレポート',
    slug: 'campaign-report',
    icon: 'file-text'
  },
  {
    url: '/products',
    name: '商品',
    slug: 'products',
    icon: 'package'
  },
  {
    name: 'CSVレポート',
    slug: 'csv_report_group',
    icon: 'file',
    submenu: [
      {
        name: '売上レポート',
        slug: 'sales-reports',
        submenu: [
          {
            url: '/sales-reports/asin',
            name: 'ASIN別',
            slug: 'sales-reports-asin',
            i18n: 'ASIN別'
          },
          {
            url: '/sales-reports/asinbyday',
            name: 'ASIN×日別',
            slug: 'sales-reports-asinbyday',
            i18n: 'ASIN×日別'
          },
          {
            url: '/sales-reports/asinbymonth',
            name: 'ASIN×月別',
            slug: 'sales-reports-asinbymonth',
            i18n: 'ASIN×月別'
          },
          {
            url: '/sales-reports/byday',
            name: '日別',
            slug: 'sales-reports-byday',
            i18n: '日別'
          },
          {
            url: '/sales-reports/bymonth',
            name: '月別',
            slug: 'sales-reports-bymonth',
            i18n: '月別'
          }
        ],
        iconSmall: true
      },
      {
        name: '利益レポート',
        slug: 'report',
        submenu: [
          {
            url: '/reports/asin',
            name: 'ASIN別',
            slug: 'reports-asin',
            i18n: 'ASIN別'
          },
          {
            url: '/reports/asinbyday',
            name: 'ASIN×日別',
            slug: 'reports-asinbyday',
            i18n: 'ASIN×日別'
          },
          {
            url: '/reports/asinbymonth',
            name: 'ASIN×月別',
            slug: 'reports-asinbymonth',
            i18n: 'ASIN×月別'
          },
          {
            url: '/reports/byday',
            name: '日別',
            slug: 'reports-byday',
            i18n: '日別'
          },
          {
            url: '/reports/bymonth',
            name: '月別',
            slug: 'reports-bymonth',
            i18n: '月別'
          }
        ],
        iconSmall: true
      },
      {
        url: '/keyword-reports',
        name: '広告キーワードレポート',
        slug: 'keyword-reports'
      }
    ]
  },
  {
    name: 'AMC',
    slug: 'amc-separator',
    isSeparator: true
  },
  {
    name: 'レポート',
    slug: 'amc_report_group',
    icon: 'database',
    submenu: [
      {
        name: 'リテンションレポート',
        slug: 'retention-report',
        iconSmall: true,
        submenu: [
          {
            url: '/amc-reports/repeat',
            name: 'リピート分析',
            slug: 'amc-reports-repeat',
          },
          {
            url: '/amc-reports/arpu',
            name: 'ARPU分析',
            slug: 'amc-reports-arpu',
          },
          {
            url: '/amc-reports/rfm',
            name: 'RFM分析',
            slug: 'amc-reports-rfm',
          },
          {
            url: '/amc-reports/ad-campaign',
            name: '広告キャンペーン分析',
            slug: 'amc-reports-ad-campaign',
          },
          {
            url: '/amc-reports/ad-keyword',
            name: '広告キーワード分析',
            slug: 'amc-reports-ad-keyword',
          },
        ],
      },
      {
        name: 'セグメント',
        slug: 'segment',
        iconSmall: true,
        submenu: [
          {
            url: '/amc-reports/segment',
            name: '注文率分析',
            slug: 'amc-reports-segment',
          },
          {
            url: '/amc-reports/affinity',
            name: 'アフィニティ分析',
            slug: 'amc-reports-affinity',
          },
        ],
      },
      {
        url: '/amc-reports/brand-reports',
        name: 'ブランドレポート',
        slug: 'amc-brand-reports',
      },
      {
        url: '/amc-reports/ec-user-analysis',
        name: '自社ECユーザー分析',
        slug: 'amc-reports-ec-user-analysis'
      },
      {
        url: '/amc-reports/setting',
        name: 'AMCレポート設定',
        slug: 'amc-reports-setting'
      }
    ]
  },
  {
    url: '/amc-reports/audience',
    name: 'オーディエンス作成',
    slug: 'amc-reports-audience',
    icon: 'user-check'
  },
  {
    name: '自動化',
    isSeparator: true
  },
  {
    url: '/ad-bid',
    name: '広告自動入札',
    slug: 'ad-bid',
    icon: 'flag'
  },
  {
    url: '/review-request',
    name: 'レビューリクエスト',
    slug: 'review-request',
    icon: 'message-square'
  },
  {
    url: '/review-analysis',
    name: 'レビュー分析',
    slug: 'review-analysis',
    icon: 'search'
  },
  {
    name: 'モニタリング設定',
    slug: 'monitoring',
    icon: 'monitor',
    submenu: [
      {
        url: '/monitoring/keyword',
        name: 'キーワード',
        slug: 'monitoring-keyword'
      },
      {
        url: '/monitoring/asin',
        name: 'ASIN',
        slug: 'monitoring-asin'
      }
    ]
  },
  {
    name: '管理',
    isSeparator: true
  },
  {
    url: '/oauth',
    name: 'アカウント接続',
    slug: 'oauth',
    icon: 'link'
  },
  {
    url: '/reoauth',
    name: 'アカウント接続の更新',
    slug: 'reoauth',
    icon: 'link'
  },
  {
    url: '/resource',
    name: 'マニュアル',
    slug: 'resource',
    icon: 'book-open'
  },
  {
    url: '/community',
    name: 'コミュニティ',
    slug: 'community',
    icon: 'users',
    slug: 'external',
    url: 'https://www.facebook.com/groups/ubunbase',
    target: '_blank'
  },
  {
    url: '/news',
    name: 'お知らせ',
    slug: 'news',
    icon: 'bell'
  },
  {
    name: '設定',
    slug: 'settings',
    icon: 'settings',
    submenu: [
      {
        url: '/settings/account-management',
        name: 'アカウント管理',
        slug: 'account-management'
      },
      {
        url: '/settings/user-management',
        name: 'ユーザー管理',
        slug: 'user-management'
      },
      {
        url: '/settings/cancellation',
        name: '退会',
        slug: 'external',
        url: 'https://www.ubun.co.jp/base_cancellation',
        target: '_blank'
      }
    ]
  }
]
